import React, { useEffect } from "react";

/**
  Genetic Icon for new UI
  @param {string} icon - icon name
  @param {string} alt - alt text for the icon
  @param {function} onClick - callback for button click (optional)
  @param {boolean} stateChangeable - if icon is state changable (optional)
  @param {int} size - size of the icon (optional)
  @param {boolean} isSvg - if icon is svg (optional)
  @param {object} style - style of the icon (optional)
  These icons are located in assets/images/NewIcons
*/
function CustomIcon({
	icon,
	alt = "failed to load",
	onClick,
	stateChangeable = false,
	size = 25,
	isSvg = true,
	className = "",
	style = {},
}) {
	const [isHovered, setIsHovered] = React.useState(false);
	const [iconSrc, setIconSrc] = React.useState(null);

	useEffect(() => {
		import(
			`../../assets/images/NewIcons/${isHovered && stateChangeable ? `${icon}_selected` : icon}.${isSvg ? "svg" : "png"}`
		)
			.then((src) => {
				setIconSrc(src.default);
			})
			.catch((e) => {});
	}, [isHovered, icon, isSvg, stateChangeable]);

	try {
		return (
			<img
				style={{ ...style, width: size, height: size }}
				className={`${className} icon-ant`}
				onClick={onClick}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						onClick();
					}
				}}
				alt={alt}
				src={iconSrc}
			/>
		);
	} catch (e) {
		return <img width={size} alt={alt} />;
	}
}

export default CustomIcon;
